module.exports = __webpack_public_path__ + "explore/Components/ExploreHeader/close.56bae6b566ebca6ab4d91c59ee18a574.svg";